<template>
	<v-card>
		<v-card-title>
			<h2>Powiadomienia systemowe</h2>
		</v-card-title>
		<v-card-text>
			<v-container fluid>
				<v-flex v-for="mailType in contents" :key="mailType.type" mb-5>
					<v-layout wrap>
						<v-flex xs12>
							<h3>{{mailType.typeName}}</h3>
						</v-flex>
						<v-flex mt-2 mb-3 xs12 v-if="mailType.additionalInfo">
							<h4 style="white-space: pre;">{{ mailType.additionalInfo }}</h4>
						</v-flex>
						<v-flex xs11 md9 lg6>
							<v-textarea browser-autocomplete="off" outline auto-grow label="Treść powiadomienia"
								v-model="mailType.text" aria-label="mail text"></v-textarea>
						</v-flex>
					</v-layout>
					<v-layout>
						<v-btn @click="send(mailType)" :disabled="!mailType.text">Zapisz zmiany</v-btn>
					</v-layout>
				</v-flex>
			</v-container>
		</v-card-text>
	</v-card>
</template>

<script>
	import {EmailContents} from "@/api/generated/EmailContents";

	export default {
		name: "EmailContentsView",

		created () {
			this.refresh();
		},

		data () {
			return {
				contents: [],
			};
		},

		methods: {
      refresh () {
        this.loadData();
      },

      loadData () {
        EmailContents.get(this, response => {
          response = Object.entries(response);
          response = response.slice(4);
          this.contents = [];
          this.contents.push(this.getFullEntry(response, 'verificationMessageAfterRegistrationEmailContents'));
          this.contents.push(this.getFullEntry(response, 'accountAcceptanceEmailContents'));
          this.contents.push(this.getFullEntry(response, 'accountActivationEmailContents'));
          this.contents.push(this.getFullEntry(response, 'accountDeactivationEmailContents'));
          this.contents.push(this.getFullEntry(response, 'verificationMessagePasswordResetEmailContents'));
          this.contents.push(this.getFullEntry(response, 'resetEmailConfirmationEmailContents'));
          this.contents.push(this.getFullEntry(response, 'changeBidderEmailTokenEmailContents'));
          this.contents.push(this.getFullEntry(response, 'verificationMessageAfterEmailChangeEmailContents'));
          this.contents.push(this.getFullEntry(response, 'bidderMutualOfferInvitationEmailContents'));
          this.contents.push(this.getFullEntry(response, 'mainBidderOfferInvitationEmailContents'));
          this.contents.push(this.getFullEntry(response, 'volunteerInSubmittedOfferEmailContents'));
          this.contents.push(this.getFullEntry(response, 'offerCompletedAndAwaitingMainBidderEmailContents'));
          this.contents.push(this.getFullEntry(response, 'offerCompletedAndAwaitingOtherBiddersEmailContents'));
          this.contents.push(this.getFullEntry(response, 'offerMainBidderRejectedEmailContents'));
          this.contents.push(this.getFullEntry(response, 'offerMutualBidderRejectedEmailContents'));
          this.contents.push(this.getFullEntry(response, 'offerSubmittedEmailContents'));
          this.contents.push(this.getFullEntry(response, 'requestOfferChangesEmailContents'));
          this.contents.push(this.getFullEntry(response, 'requestUndoOfferChangesEmailContents'));
          this.contents.push(this.getFullEntry(response, 'requestProjectChangesEmailContents'));
          this.contents.push(this.getFullEntry(response, 'requestUndoProjectChangesEmailContents'));
          this.contents.push(this.getFullEntry(response, 'mainBidderProjectInvitationEmailContents'));
          this.contents.push(this.getFullEntry(response, 'projectCompletedAndAwaitingMainBidderEmailContents'));
          this.contents.push(this.getFullEntry(response, 'projectMainBidderRejectedEmailContents'));
          this.contents.push(this.getFullEntry(response, 'mainBidderReportInvitationEmailContents'));
          this.contents.push(this.getFullEntry(response, 'reportCompletedAndAwaitingMainBidderEmailContents'));
          this.contents.push(this.getFullEntry(response, 'reportMainBidderRejectedEmailContents'));
          this.contents.push(this.getFullEntry(response, 'requestFinalReportChangesEmailContents'));
          this.contents.push(this.getFullEntry(response, 'requestUndoFinalReportChangesEmailContents'));
          this.contents.push(this.getFullEntry(response, 'projectFinalReportApprovedEmailContents'));
          this.contents.push(this.getFullEntry(response, 'volunteerReportDatesEmailContents'));
          this.contents.push(this.getFullEntry(response, 'requestVolunteerReportChangesEmailContents'));
          this.contents.push(this.getFullEntry(response, 'requestAgencyProjectChangesEmailContents'));
          this.contents.push(this.getFullEntry(response, 'requestUndoAgencyProjectChangesEmailContents'));
          this.contents.push(this.getFullEntry(response, 'requestApprovedAgencyProjectChangesEmailContents'));
          this.contents.push(this.getFullEntry(response, 'requestUndoApprovedAgencyProjectChangesEmailContents'));
          this.contents.push(this.getFullEntry(response, 'inappropriateAssignmentNotificationEmailContents'));
          this.contents.push(this.getFullEntry(response, 'inappropriateAgencyProjectAssignmentNotificationEmailContents'));
          this.contents.push(this.getFullEntry(response, 'offerEvaluationRejectedEmailContents'));
          this.contents.push(this.getFullEntry(response, 'agencyProjectEvaluationRejectedEmailContents'));
        });
      },

      getFullEntry (response, key) {
        let item = response.find(obj => obj[0] === key);
        let type = this.getEmailType(item[0]);
        let typeName = this.getEmailTypeName(type);
        let text = item[1];
        let additionalInfo = this.getAdditionalInfo(type);

        return {
          type: type,
          typeName: typeName,
          text: text,
          additionalInfo: additionalInfo
        };
      },

      getEmailType (name) {
        //funkcja tworząca nazwę typu jak w Javowym enumie na podstawie nazwy pola
        name = name.substring(0, name.length - "EmailContents".length); //odetnij końcówkę
        name = name.split(/(?=[A-Z])/).join(" "); //podziel na słowa
        name = name.toUpperCase(); //toUpperCase
        name = name.replace(/ /g, "_"); //zamień spacje na podłogi
        return name;
      },

      getEmailTypeName (type) {
        switch (type) {
          case "CHANGE_BIDDER_EMAIL_TOKEN":
            return "Zmiana głównego maila konta (loginu) wykonywana w oknie logowania";
          case "VERIFICATION_MESSAGE_AFTER_EMAIL_CHANGE":
            return "Potwierdzenie zmiany głównego maila konta (loginu) wykonanej w oknie logowania";
          case "VERIFICATION_MESSAGE_PASSWORD_RESET":
            return "Zmiana hasła";
          case "VERIFICATION_MESSAGE_AFTER_REGISTRATION":
            return "Potwierdzenie rejestracji";
          case "BIDDER_MUTUAL_OFFER_INVITATION":
            return "Zaproszenie do wspólnego udziału w składaniu oferty";
          case "MAIN_BIDDER_OFFER_INVITATION":
            return "Informacja o konieczności potwierdzenia oferty utworzonej na subkoncie";
          case "MAIN_BIDDER_PROJECT_INVITATION":
            return "Informacja o konieczności potwierdzenia poprawek do projektu wprowadzonych na subkoncie";
          case "MAIN_BIDDER_REPORT_INVITATION":
            return "Informacja o konieczności potwierdzenia sprawozdania złożonego przez subkonto";
          case "OFFER_COMPLETED_AND_AWAITING_MAIN_BIDDER":
            return "Oferta uzupełniona i oczekuje na potwierdzenie konta nadrzędnego";
          case "OFFER_COMPLETED_AND_AWAITING_OTHER_BIDDERS":
            return "Oferta uzupełniona i oczekuje na potwierdzenie współoferentów";
          case "PROJECT_COMPLETED_AND_AWAITING_MAIN_BIDDER":
            return "Projekt uzupełniony i oczekuje na potwierdzenie głównego oferenta";
          case "REPORT_COMPLETED_AND_AWAITING_MAIN_BIDDER":
            return "Sprawozdanie złożone i oczekuje na potwierdzenie głównego oferenta";
          case "OFFER_SUBMITTED":
            return "Oferta wysłana";
          case "VOLUNTEER_IN_SUBMITTED_OFFER":
            return "Informacja o uwzględnieniu wolontariusza w ofercie";
          case "RESET_EMAIL_CONFIRMATION":
            return "Potwierdzenie zmiany głównego maila konta (loginu) wykonanej w menu użytkownika";
          case "REQUEST_OFFER_CHANGES":
            return "Informacja o udostępnieniu oferty do poprawki";
          case "REQUEST_PROJECT_CHANGES":
            return "Informacja o udostępnieniu projektu do poprawki";
          case "REQUEST_AGENCY_PROJECT_CHANGES":
            return "Informacja o udostępnieniu wniosku do poprawki";
          case "REQUEST_APPROVED_AGENCY_PROJECT_CHANGES":
            return "Informacja o udostępnieniu projektu placówki do poprawki";
          case "REQUEST_UNDO_OFFER_CHANGES":
            return "Informacja o wycofaniu oferty z poprawki";
          case "REQUEST_UNDO_PROJECT_CHANGES":
            return "Informacja o wycofaniu projektu z poprawki";
          case "REQUEST_UNDO_AGENCY_PROJECT_CHANGES":
            return "Informacja o wycofaniu wniosku z poprawki";
          case "REQUEST_UNDO_APPROVED_AGENCY_PROJECT_CHANGES":
            return "Informacja o wycofaniu projektu placówki z poprawki";
          case "REQUEST_VOLUNTEER_REPORT_CHANGES":
            return "Informacja o udostępnieniu raportu wolontariusza do poprawki";
          case "REQUEST_FINAL_REPORT_CHANGES":
            return "Informacja o konieczności wprowadzenia poprawek do sprawozdania końcowego";
          case "REQUEST_UNDO_FINAL_REPORT_CHANGES":
            return "Informacja o wycofaniu sprawozdania końcowego z poprawki";
          case "ACCOUNT_ACCEPTANCE":
            return "Informacja o akceptacji konta";
          case "ACCOUNT_ACTIVATION":
            return "Informacja o aktywacji konta";
          case "ACCOUNT_DEACTIVATION":
            return "Informacja o dezaktywacji konta";
          case "INAPPROPRIATE_ASSIGNMENT_NOTIFICATION":
            return "Powiadomienie o niewłaściwym przypisaniu opinii konkursowej";
          case "VOLUNTEER_REPORT_DATES":
            return "Terminy przekazania raportów wolontariusza";
          case "OFFER_MAIN_BIDDER_REJECTED":
            return "Niezaakceptowanie oferty przez konto nadrzędne";
          case "OFFER_MUTUAL_BIDDER_REJECTED":
            return "Niezaakceptowanie oferty przez współoferenta";
          case "INAPPROPRIATE_AGENCY_PROJECT_ASSIGNMENT_NOTIFICATION":
            return "Powiadomienie o niewłaściwym przypisaniu opinii w naborze wniosków placówek";
          case "PROJECT_FINAL_REPORT_APPROVED":
            return "Powiadomienie o zaakceptowaniu sprawozdania końcowego w projekcie";
          case "PROJECT_MAIN_BIDDER_REJECTED":
            return "Niezaakceptowanie projektu przez głównego oferenta";
          case "REPORT_MAIN_BIDDER_REJECTED":
            return "Niezaakceptowanie sprawozdania przez głównego oferenta";
          case "OFFER_EVALUATION_REJECTED":
            return "Odesłanie opinii dot. oferty konkursowej";
          case "AGENCY_PROJECT_EVALUATION_REJECTED":
            return "Odesłanie opinii dot. wniosku placówki";
        }
      },

      getAdditionalInfo (type) {
        switch (type) {
          case "CHANGE_BIDDER_EMAIL_TOKEN":
          case "VERIFICATION_MESSAGE_AFTER_EMAIL_CHANGE":
          case "VERIFICATION_MESSAGE_PASSWORD_RESET":
          case "VERIFICATION_MESSAGE_AFTER_REGISTRATION":
          case "BIDDER_MUTUAL_OFFER_INVITATION":
          case "MAIN_BIDDER_OFFER_INVITATION":
          case "MAIN_BIDDER_PROJECT_INVITATION":
          case "MAIN_BIDDER_REPORT_INVITATION":
          case "RESET_EMAIL_CONFIRMATION":
          case "OFFER_MAIN_BIDDER_REJECTED":
          case "OFFER_MUTUAL_BIDDER_REJECTED":
          case "PROJECT_MAIN_BIDDER_REJECTED":
          case "REPORT_MAIN_BIDDER_REJECTED":
            return "W następnej linii po powiadomieniu zostanie wklejony link.";
          case "OFFER_COMPLETED_AND_AWAITING_MAIN_BIDDER":
          case "OFFER_COMPLETED_AND_AWAITING_OTHER_BIDDERS":
          case "PROJECT_COMPLETED_AND_AWAITING_MAIN_BIDDER":
          case "REPORT_COMPLETED_AND_AWAITING_MAIN_BIDDER":
          case "OFFER_SUBMITTED":
          case "ACCOUNT_ACCEPTANCE":
          case "VOLUNTEER_IN_SUBMITTED_OFFER":
          case "ACCOUNT_ACTIVATION":
          case "ACCOUNT_DEACTIVATION":
          case "REQUEST_UNDO_OFFER_CHANGES":
          case "REQUEST_UNDO_PROJECT_CHANGES":
          case "REQUEST_UNDO_AGENCY_PROJECT_CHANGES":
          case "REQUEST_UNDO_APPROVED_AGENCY_PROJECT_CHANGES":
          case "REQUEST_UNDO_FINAL_REPORT_CHANGES":
            return null;
          case "REQUEST_OFFER_CHANGES":
          case "REQUEST_PROJECT_CHANGES":
          case "REQUEST_AGENCY_PROJECT_CHANGES":
          case "REQUEST_APPROVED_AGENCY_PROJECT_CHANGES":
          case "REQUEST_VOLUNTEER_REPORT_CHANGES":
          case "REQUEST_FINAL_REPORT_CHANGES":
            return "W następnej linii po powiadomieniu zostanie wklejona wiadomość wypełniana przy oddawaniu do poprawek.";
          case "INAPPROPRIATE_ASSIGNMENT_NOTIFICATION":
            return "W następnej linii po powiadomieniu zostanie wklejona informacja postaci: \n" +
                "\"Opinia [typ opinii] do oferty [nazwa oferty] ([numer oferty]) w konkursie [nazwa konkursu]\".";
          case "INAPPROPRIATE_AGENCY_PROJECT_ASSIGNMENT_NOTIFICATION":
            return "W następnej linii po powiadomieniu zostanie wklejona informacja postaci: \n" +
                "\"Opinia [typ opinii] do wniosku [nazwa wniosku] ([numer wniosku]) w naborze wniosków placówek [nazwa naboru]\".";
          case "VOLUNTEER_REPORT_DATES":
            return "Tytuł powiadomienia: \"Egranty - Terminy przekazania raportów w projekcie: [nazwa projektu]\".\n" +
                "W następnych liniach po powiadomieniu zostanie wklejona informacja postaci: \n" +
                "\"Raport nr [numer raportu]: [termin przekazania]\".";
          case "PROJECT_FINAL_REPORT_APPROVED":
            return "W pierwszej linii zostanie wklejona informacja postaci: \n" +
                "\"Sprawozdanie końcowe w projekcie [nazwa projektu] zostało zaakceptowane.\"";
          case "OFFER_EVALUATION_REJECTED":
          case "AGENCY_PROJECT_EVALUATION_REJECTED":
            return "W następnej linii po powiadomieniu zostanie wklejony powód odrzucenia opinii";
        }
      },

			send (mailType) {
				EmailContents.put(this, mailType.type, {body: mailType.text}, successResponse => {
						this.$messagesBus.$emit("success", "Pomyślnie zapisano zmiany", successResponse);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się zapisać zmian", errorResponse);
					});
			},
		},
	};
</script>

<style scoped>

</style>
